import { versionGroupToGeneration } from "../hooks/useGeneration";
import { compare } from "./compare";
import { Generation } from "./data-generations";
import {
  AbilityName,
  CoverageType,
  SpecialMove,
  Type,
  abilities,
  typesForVersionGroup,
} from "./data-types";
import { VersionGroup } from "./data-version-groups";

export const battleVariants = ["regular", "inverse_battle"] as const;
export type BattleVariant = (typeof battleVariants)[number];

const typesInPokemondbOrder = [
  Type.normal,
  Type.fire,
  Type.water,
  Type.electric,
  Type.grass,
  Type.ice,
  Type.fighting,
  Type.poison,
  Type.ground,
  Type.flying,
  Type.psychic,
  Type.bug,
  Type.rock,
  Type.ghost,
  Type.dragon,
  Type.dark,
  Type.steel,
  Type.fairy,
  Type.stellar,
];

const _ = 1;
const h = 1 / 2;
const x = NaN;

const gen1 = [
  [_, _, _, _, _, _, _, _, _, _, _, _, h, 0, _, x, x, x, x],
  [_, h, h, _, 2, 2, _, _, _, _, _, 2, h, _, h, x, x, x, x],
  [_, 2, h, _, h, _, _, _, 2, _, _, _, 2, _, h, x, x, x, x],
  [_, _, 2, h, h, _, _, _, 0, 2, _, _, _, _, h, x, x, x, x],
  [_, h, 2, _, h, _, _, h, 2, h, _, h, 2, _, h, x, x, x, x],
  [_, _, h, _, 2, h, _, _, 2, 2, _, _, _, _, 2, x, x, x, x],
  [2, _, _, _, _, 2, _, h, _, h, h, h, 2, 0, _, x, x, x, x],
  [_, _, _, _, 2, _, _, h, h, _, _, 2, h, h, _, x, x, x, x],
  [_, 2, _, 2, h, _, _, 2, _, 0, _, h, 2, _, _, x, x, x, x],
  [_, _, _, h, 2, _, 2, _, _, _, _, 2, h, _, _, x, x, x, x],
  [_, _, _, _, _, _, 2, 2, _, _, h, _, _, _, _, x, x, x, x],
  [_, h, _, _, 2, _, h, 2, _, h, 2, _, _, h, _, x, x, x, x],
  [_, 2, _, _, _, 2, h, _, h, 2, _, 2, _, _, _, x, x, x, x],
  [0, _, _, _, _, _, _, _, _, _, 0, _, _, 2, _, x, x, x, x],
  [_, _, _, _, _, _, _, _, _, _, _, _, _, _, 2, x, x, x, x],
  [x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x],
  [x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x],
  [x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x],
  [x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x],
  [x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x],
];

const gen2 = [
  [_, _, _, _, _, _, _, _, _, _, _, _, h, 0, _, _, h, x, x],
  [_, h, h, _, 2, 2, _, _, _, _, _, 2, h, _, h, _, 2, x, x],
  [_, 2, h, _, h, _, _, _, 2, _, _, _, 2, _, h, _, _, x, x],
  [_, _, 2, h, h, _, _, _, 0, 2, _, _, _, _, h, _, _, x, x],
  [_, h, 2, _, h, _, _, h, 2, h, _, h, 2, _, h, _, h, x, x],
  [_, h, h, _, 2, h, _, _, 2, 2, _, _, _, _, 2, _, h, x, x],
  [2, _, _, _, _, 2, _, h, _, h, h, h, 2, 0, _, 2, 2, x, x],
  [_, _, _, _, 2, _, _, h, h, _, _, _, h, h, _, _, 0, x, x],
  [_, 2, _, 2, h, _, _, 2, _, 0, _, h, 2, _, _, _, 2, x, x],
  [_, _, _, h, 2, _, 2, _, _, _, _, 2, h, _, _, _, h, x, x],
  [_, _, _, _, _, _, 2, 2, _, _, h, _, _, _, _, 0, h, x, x],
  [_, h, _, _, 2, _, h, h, _, h, 2, _, _, h, _, 2, h, x, x],
  [_, 2, _, _, _, 2, h, _, h, 2, _, 2, _, _, _, _, h, x, x],
  [0, _, _, _, _, _, _, _, _, _, 2, _, _, 2, _, h, h, x, x],
  [_, _, _, _, _, _, _, _, _, _, _, _, _, _, 2, _, h, x, x],
  [_, _, _, _, _, _, h, _, _, _, 2, _, _, 2, _, h, h, x, x],
  [_, h, h, h, _, 2, _, _, _, _, _, _, 2, _, _, _, h, x, x],
  [x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x],
];

const genDefault = [
  [_, _, _, _, _, _, _, _, _, _, _, _, h, 0, _, _, h, _, _],
  [_, h, h, _, 2, 2, _, _, _, _, _, 2, h, _, h, _, 2, _, _],
  [_, 2, h, _, h, _, _, _, 2, _, _, _, 2, _, h, _, _, _, _],
  [_, _, 2, h, h, _, _, _, 0, 2, _, _, _, _, h, _, _, _, _],
  [_, h, 2, _, h, _, _, h, 2, h, _, h, 2, _, h, _, h, _, _],
  [_, h, h, _, 2, h, _, _, 2, 2, _, _, _, _, 2, _, h, _, _],
  [2, _, _, _, _, 2, _, h, _, h, h, h, 2, 0, _, 2, 2, h, _],
  [_, _, _, _, 2, _, _, h, h, _, _, _, h, h, _, _, 0, 2, _],
  [_, 2, _, 2, h, _, _, 2, _, 0, _, h, 2, _, _, _, 2, _, _],
  [_, _, _, h, 2, _, 2, _, _, _, _, 2, h, _, _, _, h, _, _],
  [_, _, _, _, _, _, 2, 2, _, _, h, _, _, _, _, 0, h, _, _],
  [_, h, _, _, 2, _, h, h, _, h, 2, _, _, h, _, 2, h, h, _],
  [_, 2, _, _, _, 2, h, _, h, 2, _, 2, _, _, _, _, h, _, _],
  [0, _, _, _, _, _, _, _, _, _, 2, _, _, 2, _, h, _, _, _],
  [_, _, _, _, _, _, _, _, _, _, _, _, _, _, 2, _, h, 0, _],
  [_, _, _, _, _, _, h, _, _, _, 2, _, _, 2, _, h, _, h, _],
  [_, h, h, h, _, 2, _, _, _, _, _, _, 2, _, _, _, h, 2, _],
  [_, h, _, _, _, _, 2, h, _, _, _, _, _, _, 2, 2, h, _, _],
  [_, _, _, _, _, _, _, _, _, _, _, _, _, _, _, _, _, _, _],
];

const generationMatchupData = {
  gen1: gen1,
  gen2: gen2,
  default: genDefault,
};

function matchupForPair(
  gen: Generation,
  defenseType: Type,
  offenseType: Type,
): number {
  const map = generationMatchupMaps[gen];
  const key = getKey(offenseType, defenseType);
  const val = map.get(key);
  if (val === undefined) {
    // eslint-disable-next-line no-console
    console.error(`matchupForPair: ${key}`);
    return NaN;
  }
  return val;
}

interface PartitionedMatchups {
  weakness: CoverageType[];
  resistance: CoverageType[];
  normal: CoverageType[];
}

export function partitionMatchups({
  battleVariant,
  coverageTypes,
  versionGroup,
  types,
  offenseAbilities,
  specialMoves,
}: {
  battleVariant: BattleVariant;
  coverageTypes: CoverageType[];
  versionGroup: VersionGroup;
  types: Type[];
  offenseAbilities: AbilityName[];
  specialMoves: SpecialMove[];
}): PartitionedMatchups {
  const ret: PartitionedMatchups = {
    weakness: [],
    resistance: [],
    normal: [],
  };
  for (const ct of coverageTypes) {
    const arr: number[] = [];
    let abilities = [...offenseAbilities];
    if (abilities.length === 0) {
      abilities = ["none"];
    }
    let moves: readonly (SpecialMove | undefined)[] = [...specialMoves];
    if (moves.length === 0) {
      moves = [undefined];
    } else if (moves.includes("flying_press") && types.length > 0) {
      moves = [...specialMoves, undefined];
    }
    let offTypes: readonly (Type | undefined)[] = [...types];
    if (moves.includes("flying_press")) {
      offTypes = [...offTypes];
    }
    if (moves.includes("freeze-dry") && !offTypes.includes("ice")) {
      offTypes = [...offTypes, "ice"];
    }
    if (moves.includes("thousand_arrows") && !offTypes.includes("ground")) {
      offTypes = [...offTypes, "ground"];
    }
    if (offTypes.length === 0) {
      offTypes = [undefined];
    }
    for (const offenseAbilityName of abilities) {
      for (const specialMove of moves) {
        for (const t of offTypes) {
          arr.push(
            matchupFor({
              battleVariant,
              versionGroup,
              defenseTypes: ct.types,
              defenseTeraType: Type.none,
              offenseType: t,
              abilityName: "none",
              offenseAbilityName,
              specialMove,
            }),
          );
        }
      }
    }
    const max = Math.max(...arr);
    const min = Math.min(...arr);
    if (max > 1) {
      ret.weakness.push(ct);
    } else if (min < 1 && max < 1) {
      ret.resistance.push(ct);
    } else {
      ret.normal.push(ct);
    }
  }
  return ret;
}

export function matchupFor({
  battleVariant,
  versionGroup,
  defenseTypes,
  offenseType,
  defenseTeraType = Type.none,
  offenseAbilityName = Type.none,
  abilityName,
  specialMove,
}: {
  battleVariant: BattleVariant;
  versionGroup: VersionGroup;
  defenseTypes: Type[];
  defenseTeraType: Type;
  offenseType: Type | undefined;
  offenseAbilityName: AbilityName;
  abilityName: AbilityName;
  specialMove?: SpecialMove;
}): number {
  const generation = versionGroupToGeneration(versionGroup);
  // Flying Press is basically a Flying move and a Fighting move multiplied
  // together. So just compute those two regular attacks separately and combine
  // them.
  if (specialMove === "flying_press") {
    const opts = {
      battleVariant,
      versionGroup,
      defenseTypes,
      defenseTeraType,
      offenseAbilityName,
      abilityName,
      specialMove: undefined,
    } as const;
    const a = matchupFor({ ...opts, offenseType: "flying" });
    const b = matchupFor({ ...opts, offenseType: "fighting" });
    return a * b;
  }
  let n = 1;
  // Tera Pokémon (other than Stellar type) use their Tera type as their sole
  // defensive type
  //
  // https://bulbapedia.bulbagarden.net/wiki/Terastal_phenomenon
  if (!(defenseTeraType === Type.none || defenseTeraType === Type.stellar)) {
    defenseTypes = [defenseTeraType, Type.none];
  }
  // Apply multipliers based on ability
  if (abilityName) {
    for (const info of abilities[abilityName]) {
      if (info.type === offenseType) {
        n *= info.value;
      }
    }
  }
  // Apply multipliers based on defense types
  for (const t of defenseTypes) {
    let x = 1;
    // Don't crash if types are "none" or missing
    if (t !== Type.none && offenseType) {
      x = matchupForPair(generation, t, offenseType);
    }
    // Ghost can be hurt normally by Normal and Fighting
    //
    // https://bulbapedia.bulbagarden.net/wiki/Scrappy_(Ability)
    if (
      offenseAbilityName === "scrappy" &&
      t === Type.ghost &&
      (offenseType === Type.normal || offenseType === Type.fighting)
    ) {
      x = 1;
    }
    if (t === Type.flying && abilityName === "delta_stream" && x > 1) {
      // Delta stream protects flying types from super effective damage
      //
      // https://bulbapedia.bulbagarden.net/wiki/Delta_Stream_(Ability)
      x = 1;
    }
    // Freeze-Dry always deals 2x to Water
    //
    // https://bulbapedia.bulbagarden.net/wiki/Freeze-Dry_(move)
    if (
      t === Type.water &&
      specialMove === "freeze-dry" &&
      offenseType === Type.ice
    ) {
      x = 2;
    }
    // During an Inverse Battle, type matchups are reversed and no type is
    // immune to any other type.
    //
    // https://bulbapedia.bulbagarden.net/wiki/Inverse_Battle
    if (battleVariant === "inverse_battle") {
      if (x === 0) {
        // Inverse of 0 is merely double damage, not infinite damage.
        x = 2;
      } else {
        // Inverses damage taken based on type
        x = 1 / x;
      }
    }
    n *= x;
  }
  // Thousand Arrows deals neutral damage to Flying-type Pokémon, regardless
  // of their secondary type, instead of the type chart's usual result
  //
  // https://bulbapedia.bulbagarden.net/wiki/Thousand_Arrows_(move)
  if (
    specialMove === "thousand_arrows" &&
    offenseType === Type.ground &&
    defenseTypes.includes(Type.flying)
  ) {
    n = 1;
  }
  // Tera Pokémon take double damage from Stellar attacks
  //
  // https://bulbapedia.bulbagarden.net/wiki/Stellar_(type)
  if (defenseTeraType !== Type.none && offenseType === Type.stellar) {
    n *= 2;
  }
  // Doubles damage of ineffective moves
  //
  // https://bulbapedia.bulbagarden.net/wiki/Tinted_Lens_(Ability)
  if (offenseAbilityName === "tinted_lens" && n < 1) {
    n *= 2;
  }
  // Wonder guard blocks all non-super effective damage
  //
  // https://bulbapedia.bulbagarden.net/wiki/Wonder_Guard_(Ability)
  if (abilityName === "wonder_guard") {
    if (n <= 1) {
      n = 0;
    }
  }
  // Reduces all super effective damage by 25%
  //
  // https://bulbapedia.bulbagarden.net/wiki/Filter_(Ability)
  // https://bulbapedia.bulbagarden.net/wiki/Solid_Rock_(Ability)
  // https://bulbapedia.bulbagarden.net/wiki/Prism_Armor_(Ability)
  if (
    abilityName === "filter" ||
    abilityName === "solid_rock" ||
    abilityName === "prism_armor"
  ) {
    if (n > 1) {
      n *= 0.75;
    }
  }
  // When Terapagos is hit by a damage-dealing move at full HP (that does not
  // have no effect due to type matchups), it will always be not very effective.
  //
  // Seeing as we don't model HP, just assume we're at full HP the whole time
  // and that people know what the ability actually does.
  //
  //https://bulbapedia.bulbagarden.net/wiki/Tera_Shell_(Ability)
  if (abilityName === "tera_shell") {
    if (n > 0) {
      n = 0.5;
    }
  }
  return n;
}

function createMatchupMap(gen: Generation): Map<string, number> {
  const map = new Map<string, number>();
  const data = generationMatchupData[gen];
  for (const [r, row] of data.entries()) {
    for (const [c, col] of row.entries()) {
      const t1 = typesInPokemondbOrder[r];
      const t2 = typesInPokemondbOrder[c];
      const key = getKey(t1, t2);
      map.set(key, col);
    }
  }
  return map;
}

function getKey(t1: Type, t2: Type): string {
  return `${t1} > ${t2}`;
}

const generationMatchupMaps = {
  gen1: createMatchupMap("gen1"),
  gen2: createMatchupMap("gen2"),
  default: createMatchupMap("default"),
};

class Matchup {
  constructor(
    // public generation: Generation,
    public types: Type[],
    public effectiveness: number,
    public formName?: string,
  ) {}
}

export class GroupedMatchups {
  constructor(public matchups: Matchup[]) {}

  toTestFormat(): Record<string, any> {
    return Object.fromEntries(
      this.matchups.map((m) => [m.types.join(" / "), m.effectiveness]),
    );
  }

  typesFor(effectivenes: number): Type[][] {
    return this.matchups
      .filter((m) => m.effectiveness === effectivenes)
      .map((m) => m.types);
  }

  groupByEffectiveness(): Matchup[][] {
    const map: Map<number, Matchup[]> = new Map();
    for (const matchup of this.matchups) {
      const list = map.get(matchup.effectiveness);
      if (list) {
        list.push(matchup);
      } else {
        map.set(matchup.effectiveness, [matchup]);
      }
    }
    const effectivenesses = Array.from(map.keys()).sort(compare).reverse();
    return effectivenesses.map((eff) => {
      const list = map.get(eff);
      if (list) {
        return list;
      }
      throw new Error(`groupByEffectiveness: ${eff}`);
    });
  }
}

function makeTypePairs(items: Type[]): [Type, Type][] {
  const ret: [Type, Type][] = [];
  const set = new Set<string>();
  const itemsOrNone = [...items, Type.none] as const;
  for (const a of items) {
    for (const b of itemsOrNone) {
      if (a === b) {
        continue;
      }
      const key1 = `${a} / ${b}`;
      const key2 = `${b} / ${a}`;
      if (set.has(key1) || set.has(key2)) {
        continue;
      }
      set.add(key1);
      ret.push([a, b]);
    }
  }
  return ret;
}

export function offensiveMatchups({
  battleVariant,
  versionGroup,
  offenseTypes,
  specialMoves,
  offenseAbilities,
  kind,
}: {
  battleVariant: BattleVariant;
  versionGroup: VersionGroup;
  offenseTypes: readonly Type[];
  specialMoves: readonly SpecialMove[];
  offenseAbilities: readonly AbilityName[];
  kind: "single" | "combination";
}): GroupedMatchups {
  const types = typesForVersionGroup(versionGroup).filter(
    (t) => t !== Type.stellar,
  );
  const typePairs =
    kind === "combination"
      ? makeTypePairs(types)
      : types.map((t) => [t, Type.none]);
  const matchups = typePairs.map(([t1, t2]) => {
    let moves: readonly (SpecialMove | undefined)[] = specialMoves;
    if (moves.length === 0) {
      moves = [undefined];
    } else if (moves.includes("flying_press") && offenseTypes.length > 0) {
      moves = [...moves, undefined];
    }
    let abilities: readonly AbilityName[] = [...offenseAbilities];
    if (offenseAbilities.length === 0) {
      abilities = ["none"];
    }
    let offTypes: readonly (Type | undefined)[] = [...offenseTypes];
    if (moves.includes("flying_press")) {
      offTypes = [...offTypes];
    }
    if (moves.includes("freeze-dry") && !offTypes.includes("ice")) {
      offTypes = [...offTypes, "ice"];
    }
    if (moves.includes("thousand_arrows") && !offTypes.includes("ground")) {
      offTypes = [...offTypes, "ground"];
    }
    if (offTypes.length === 0) {
      offTypes = [undefined];
    }
    const effs = abilities.flatMap((offenseAbilityName) => {
      return moves.flatMap((move) => {
        return offTypes.map((offense) => {
          const x = matchupFor({
            battleVariant,
            versionGroup,
            defenseTypes: [t1, t2],
            defenseTeraType: "none",
            offenseType: offense,
            abilityName: "none",
            specialMove: move,
            offenseAbilityName,
          });
          return x;
        });
      });
    });
    const max = Math.max(...effs);
    return new Matchup([t1, t2], max);
  });
  return new GroupedMatchups(matchups);
}

export function defensiveMatchups({
  battleVariant,
  versionGroup,
  defenseTypes,
  defenseTeraType,
  abilityName,
}: {
  battleVariant: BattleVariant;
  versionGroup: VersionGroup;
  defenseTypes: Type[];
  defenseTeraType: Type;
  abilityName: AbilityName;
}): GroupedMatchups {
  const matchups = typesForVersionGroup(versionGroup).map((t) => {
    const eff = matchupFor({
      battleVariant,
      versionGroup,
      defenseTypes,
      defenseTeraType,
      offenseType: t,
      abilityName,
      offenseAbilityName: "none",
    });
    return new Matchup([t], eff);
  });
  return new GroupedMatchups(matchups);
}
